import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, toRefs, ref, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import DownFileList from "@/components/DownFileList/index.vue";
import * as echarts from "echarts";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var route = useRoute();
    var apiName = route.query.apiName;
    var arr = ['histogram', 'lineChart'];
    var echartsIndex = ref([]);
    var type = arr.indexOf(route.query.type);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 选择的年份


    var selectYear = ref(new Date().getFullYear());
    var Data = reactive({
      year: new Date(),
      options: [{
        id: "histogram",
        type: 1,
        tips1: "完成总次数:",
        allNum: 0,
        tips2: "年完成:",
        thatYearnNum: 0,
        unit: '次',
        eCharts: {
          title: {
            text: ""
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          label: {
            show: true,
            position: "top",
            textStyle: {
              //数值样式
              color: "black",
              fontSize: 16
            }
          },
          series: [{
            data: [],
            type: "bar",
            itemStyle: {
              borderRadius: [2, 2, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#d3c6f2"
              }, {
                offset: 1,
                color: "#9b87d4"
              }])
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, {
        id: "lineChart",
        type: 1,
        tips1: "完成总次数:",
        allNum: 0,
        tips2: "年完成:",
        thatYearnNum: 0,
        unit: '次',
        eCharts: {
          title: {
            text: ""
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value",
            splitNumber: 5
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            data: [],
            type: "line",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "#fe9516"
                }, {
                  offset: 1,
                  color: "#ffcb8c"
                }],
                global: false
              }
            },
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              color: "#ffbd6e"
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, {
        id: "pieChart",
        type: 1,
        tips1: "完成总次数:",
        allNum: 0,
        tips2: "年完成:",
        thatYearnNum: 0,
        unit: '次',
        eCharts: {
          title: {
            text: ""
          },
          legend: {
            orient: "vertical",
            right: "150px",
            bottom: "20px"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            data: [{
              value: 0,
              name: "",
              itemStyle: {
                color: "#ff9c00"
              }
            }, {
              value: 0,
              name: "",
              itemStyle: {
                color: "#ea2525"
              }
            }],
            left: "-250px"
          }],
          tooltip: {
            trigger: "item"
          }
        }
      }]
    }); // 详情回显

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //挂载eCharts


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, code, res, item, reduce;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[apiName]({
                  start: Data.year.getFullYear() + '-01-01 00:00:00',
                  end: Data.year.getFullYear() + '-12-31 23:59:59'
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                code = _yield$globalProperti.code;
                _context.next = 7;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMyData"]();

              case 7:
                res = _context.sent;

                if (!(code == 0)) {
                  _context.next = 65;
                  break;
                }

                item = Data.options[type];
                reduce = 0;
                echartsIndex.value = [type];

                if (data.mouthly) {
                  reduce = data.mouthly.reduce(function (pre, cur) {
                    return pre + cur;
                  });
                } else {
                  reduce = data.mouthPay.reduce(function (pre, cur) {
                    return pre + cur;
                  });
                }

                item.thatYearnNum = reduce;
                _context.t0 = apiName;
                _context.next = _context.t0 === 'getUserExamCount' ? 17 : _context.t0 === 'getUserTrainCount' ? 21 : _context.t0 === 'getUserActivityCount' ? 25 : _context.t0 === 'getUserStudyCount' ? 29 : _context.t0 === 'getUserEvaluationCount' ? 41 : _context.t0 === 'getUserMeetingCount' ? 45 : _context.t0 === 'getPayable' ? 49 : _context.t0 === 'getUserAppraiseCount' ? 56 : _context.t0 === 'getUserInvestigateCount' ? 60 : 64;
                break;

              case 17:
                item.allNum = res.data.exam;
                item.eCharts.title.text = "网上考试完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 21:
                item.allNum = res.data.train;
                item.eCharts.title.text = "培训完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 25:
                item.allNum = res.data.activity;
                item.eCharts.title.text = "活动完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 29:
                item.allNum = res.data.studyRecord;
                item.eCharts.title.text = "学习记录情况";
                item.tips1 = "学习总次数:";
                item.eCharts.series[0].data = data.mouthly;
                Data.options[2].eCharts.title.text = "学习情况分析";
                Data.options[2].tips1 = "学习情况分析";
                Data.options[2].eCharts.series[0].data[0].name = '收藏';
                Data.options[2].eCharts.series[0].data[0].value = data.collectCount;
                Data.options[2].eCharts.series[0].data[1].name = '下载';
                Data.options[2].eCharts.series[0].data[1].value = data.downloadCount;
                echartsIndex.value.push(2);
                return _context.abrupt("break", 65);

              case 41:
                item.allNum = res.data.evaluation;
                item.eCharts.title.text = "考核完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 45:
                item.allNum = res.data.meeting;
                item.eCharts.title.text = "会议完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 49:
                item.allNum = res.data.money;
                item.eCharts.title.text = "党费缴纳情况";
                item.tips1 = "已缴党费统计:";
                item.tips2 = "年缴费:";
                item.unit = '元';
                item.eCharts.series[0].data = data.mouthPay;
                return _context.abrupt("break", 65);

              case 56:
                item.allNum = res.data.appraise;
                item.eCharts.title.text = "民主评议完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 60:
                item.allNum = res.data.investigate;
                item.eCharts.title.text = "调查问卷完成情况";
                item.eCharts.series[0].data = data.mouthly;
                return _context.abrupt("break", 65);

              case 64:
                return _context.abrupt("break", 65);

              case 65:
                nextTick(function () {
                  getMountEcherts();
                });

              case 66:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    var myChart = ref([]);

    var getMountEcherts = function getMountEcherts() {
      // let item= Data.options[type]
      if (myChart.value.length == 0) {
        echartsIndex.value.forEach(function (item) {
          var eChart = document.getElementById('echarts' + item);

          if (eChart) {
            myChart.value.push(echarts.init(eChart));
          }
        });
      }

      myChart.value.forEach(function (item, index) {
        var option = _objectSpread({}, Data.options[echartsIndex.value[index]].eCharts);

        item.setOption(option);
      }); // for (const index in myChart.value) {
      //   var option = {
      //     ...Data.options[index].eCharts,
      //   };
      //   (myChart.value[index] as { setOption }).setOption(option);
      // }
      // (myChart.value as { setOption }).setOption(item.eCharts)
    };

    onMounted(function () {
      // 详情
      getDetail();
    });
    watch(function () {
      return Data.year;
    }, function (val) {
      getDetail();
      selectYear.value = val.getFullYear();
    });
    return _objectSpread(_objectSpread({}, toRefs(Data)), {}, {
      type: type,
      selectYear: selectYear,
      echartsIndex: echartsIndex
    });
  }
});